var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
export var breakpointSizes = {
    XXS: 360,
    XS: 480,
    MD: 600,
    SM: 767,
    LG: 1024,
    XL: 1200,
    XXL: 1440,
};
var breakpoints = {};
Object.entries(breakpointSizes).forEach(function (_a) {
    var _b = __read(_a, 2), sizeName = _b[0], size = _b[1];
    breakpoints["min".concat(sizeName)] = "(min-width: ".concat(size, "px)");
    breakpoints["max".concat(sizeName)] = "(max-width: ".concat(size + 1, "px)");
    breakpoints["minHeight".concat(sizeName)] = "(min-height: ".concat(size, "px)");
    breakpoints["maxHeight".concat(sizeName)] = "(max-height: ".concat(size + 1, "px)");
});
export default breakpoints;
